import { BrowserModule } from "@angular/platform-browser";
import { NgModule, isDevMode, APP_INITIALIZER } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgProgressModule } from "ngx-progressbar";
import { NgProgressHttpModule } from "ngx-progressbar/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MaterialModule } from "./modules/material/material.module";
import { NgbAlertModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";
import { TranslateModule } from "@ngx-translate/core";
import { NgxPermissionsModule } from "ngx-permissions";
// Store

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SplashScreenComponent } from "./components/home/layout/splash-screen/splash-screen.component";
import { HomeComponent } from "./components/home/home/home.component";
import { HeaderMobileComponent } from "./components/home/header/header-mobile/header-mobile.component";
import { AsideLeftComponent } from "./components/home/aside-left/aside-left.component";
import { HeaderComponent } from "./components/home/header/header.component";
import { MenuHorizontalComponent } from "./components/home/header/menu-horizontal/menu-horizontal.component";
import { TopbarComponent } from "./components/home/header/topbar/topbar.component";
import { MyPageComponent } from "./components/pages/my-page/my-page.component";

import { OffcanvasDirective } from "./directives/home/offcanvas.directive";
import { MenuDirective } from "./directives/home/menu.directive";
import { SearchResultComponent } from "./components/home/layout/search-result/search-result.component";
import { NotificationComponent } from "./components/home/layout/topbar/notification/notification.component";
import { LanguageSelectorComponent } from "./components/home/layout/topbar/language-selector/language-selector.component";
import { QuickPanelComponent } from "./components/home/layout/topbar/quick-panel/quick-panel.component";
import { TabClickEventDirective } from "./directives/home/tab-click-event.directive";

import { ToggleDirective } from "./directives/home/toggle.directive";
import { UserProfileComponent } from "./components/home/layout/topbar/user-profile/user-profile.component";
import { ContentAnimateDirective } from "./directives/home/content-animate.directive";
import { ScrollTopComponent } from "./components/home/layout/scroll-top/scroll-top.component";
import { ScrollTopDirective } from "./directives/home/scroll-top.directive";
import { SubheaderComponent } from "./components/home/header/subheader/subheader.component";
import { Subheader1Component } from "./components/home/subheader/subheader1/subheader1.component";
import { FooterComponent } from "./components/home/footer/footer.component";
import { LoginComponent } from "./components/pages/login/login.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpInterceptorService } from "./services/httpInteceptor/http-interceptor.service";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { environment } from "../environments/environment";
import { DateTimeAgoPipePipe } from "../app/pipes/date-time-ago/date-time-ago-pipe.pipe";
import { UtilsModule } from "./modules/utils/utils.module";
import { initializeApp } from "firebase/app";
import { BrandComponent } from "./components/home/brand/brand.component";

import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ecologyState } from "./store";
import { NgxsModule } from "@ngxs/store";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { NgxsStoragePluginModule, StorageOption } from "@ngxs/storage-plugin";

initializeApp(environment.firebase);

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelSpeed: 0.5,
  swipeEasing: true,
  minScrollbarLength: 40,
  maxScrollbarLength: 300,
};
@NgModule({
  declarations: [
    AppComponent,
    SplashScreenComponent,
    HomeComponent,
    HeaderMobileComponent,
    AsideLeftComponent,
    HeaderComponent,
    MenuHorizontalComponent,
    OffcanvasDirective,
    MenuDirective,
    MyPageComponent,
    TopbarComponent,
    SearchResultComponent,
    NotificationComponent,
    LanguageSelectorComponent,
    QuickPanelComponent,
    TabClickEventDirective,
    ToggleDirective,
    UserProfileComponent,
    ContentAnimateDirective,
    ScrollTopComponent,
    ScrollTopDirective,
    SubheaderComponent,
    Subheader1Component,
    FooterComponent,
    LoginComponent,
    DateTimeAgoPipePipe,
    BrandComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    HttpClientModule,
    NgProgressModule,
    NgProgressHttpModule,
    PerfectScrollbarModule,
    TranslateModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbAlertModule,
    BrowserAnimationsModule,
    NgxMatSelectSearchModule,
    InfiniteScrollModule,
    // AngularFireMessagingModule,
    UtilsModule,
    NgxsModule.forRoot(ecologyState),
    NgxsStoragePluginModule.forRoot({
      storage: StorageOption.LocalStorage,
    }),
    NgxsReduxDevtoolsPluginModule.forRoot(),
  ],
  exports: [],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
